export const initials = (name = '') =>
  (name || '')
    .split(' ')
    .map(nameParts => nameParts.slice(0, 1).toUpperCase())
    .join('')
